import { useDispatch } from "react-redux"
import { useNavigate } from "react-router-dom"
import {
  Box,
  Button,
  Card,
  CardContent,
  Stack,
  Typography,
} from "@mui/material"
import { setCheckoutOption } from "src/features/checkout/checkoutSlice"
import { DELIVERY_OPTIONS } from "src/app/constants"
import kakaakowineMap from "src/assets/kakaakowine-map.jpg"

export default function WarehousePickupCard() {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  return (
    <Card>
      <CardContent>
        <Typography
          align="center"
          variant="overline"
          fontSize={16}
          fontWeight="700"
          lineHeight={1}
        >
          Warehouse Pickup (Mapunapuna)
        </Typography>

        <Box marginTop={1}>
          <Button
            variant="contained"
            fullWidth
            size="large"
            color="primary"
            onClick={() => {
              dispatch(
                setCheckoutOption({
                  deliveryOption: DELIVERY_OPTIONS.LOCAL_PICKUP,
                  zip: null,
                  specialEvent: null,
                }),
              )
              navigate("../schedule")
            }}
          >
            Go
          </Button>
        </Box>

        <Box my={2}>
          <img src={kakaakowineMap} width="100%" />
        </Box>

        <Stack
          direction="row"
          justifyContent="center"
          spacing={2}
          marginBottom={1}
        >
          <Typography variant="body1">WEEKDAYS:</Typography>
          <Typography variant="body1">10:00 AM - 4:00 PM</Typography>
        </Stack>

        <Stack
          direction="row"
          justifyContent="center"
          spacing={3}
          marginBottom={2}
        >
          <Typography variant="body1">WEEKENDS:</Typography>
          <Typography variant="body1">3:00 PM - 4:00 PM</Typography>
        </Stack>
      </CardContent>
    </Card>
  )
}
